export const setup = (_jsx, _jsxs) => {
    globalThis._uni = {
        _jsx,
        _jsxs: _jsxs || _jsx
    };
};
